module.exports = __webpack_public_path__ + "img/LATAM_FERMENTED_MILK.67453d8f.png";